import { useMutation, useQueryClient } from 'react-query';
import { useActionLogger } from '@/shared/hooks/action-logger';
import { createMigrator } from '..';
export const useCreateMigrator = () => {
    const queryClient = useQueryClient();
    const { setAction } = useActionLogger();
    return useMutation(createMigrator, {
        onSuccess: () => {
            queryClient.invalidateQueries('GetMigratorList');
            setAction({
                type: 'success',
                message: 'The creation of the migrator was successful',
            });
        },
        onError: (error) => {
            setAction({
                type: 'error',
                message: error.toString(),
            });
        },
    });
};
